import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo12/dnidelante.png";
import Imagen2 from "../../../images/modulo12/dniatras.png";
import GuiaDocente from "../../../components/GuiaDocente";
import ImageUploading from "react-images-uploading";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad8.mp3";

const Actividad9 = () => {
  const [images, setImages] = useState([]);
  const [imagesHuella, setImagesHuella] = useState([]);

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    setImages(imageList);
  };
  const onChangeHuella = (imageList, addUpdateIndex) => {
    // data for submit
    setImagesHuella(imageList);
  };

  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[10];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[9].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[9].path}`,
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[11].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[11].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-4">
            <li>
              El DNI es el documento nacional de identificación que todos los
              peruanos y peruanas tenemos. Es para niños y niñas, hombres y
              mujeres, pobladores del campo o de la ciudad.
            </li>
            <li>
              Te presentamos un modelo de DNI que hemos creado, donde se destaca
              el origen de nuestras familias.
            </li>
            <li>
              Completa tu DNI con los datos requeridos. Además, carga una foto
              de tu rostro y otra de tu huella digital donde corresponda.
            </li>
          </ul>
        </div>
        <div className="col-lg-10 col-12 position-relative">
          <img src={Imagen1} alt="Electores" className="img-fluid" />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-1"
          />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-2"
          />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-3"
          />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-4"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-5"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-6"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-7"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-8"
          />
          <ImageUploading
            value={images}
            onChange={onChange}
            dataURLKey="data_url"
          >
            {({
              imageList,
              onImageUpload,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper img-wrapper-1">
                <button
                  style={isDragging ? { color: "red" } : undefined}
                  className="btn btn-sm btn-dark"
                  onClick={onImageUpload}
                  {...dragProps}
                >
                  Cargar foto
                </button>
                &nbsp;
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img
                      src={image["data_url"]}
                      alt=""
                      width="100"
                      className="my-1"
                    />
                    <div className="image-item__btn-wrapper">
                      <button
                        onClick={() => onImageUpdate(index)}
                        className="btn btn-sm btn-dark me-1"
                      >
                        Cambiar
                      </button>
                      <button
                        onClick={() => onImageRemove(index)}
                        className="btn btn-sm btn-dark"
                      >
                        Borrar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </div>
        <div className="col-lg-10 col-12 position-relative">
          <img src={Imagen2} alt="Electores" className="img-fluid" />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-9"
          />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-10"
          />
          <input
            type="text"
            className="form-control form-control-sm w-300 input-dni-11"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-12"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-13"
          />
          <input
            type="text"
            className="form-control form-control-sm w-120 input-dni-14"
          />
          <ImageUploading
            value={imagesHuella}
            onChange={onChangeHuella}
            dataURLKey="data_url"
          >
            {({
              imageList,
              onImageUpload,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper img-wrapper-2">
                <button
                  style={isDragging ? { color: "red" } : undefined}
                  className="btn btn-sm btn-dark"
                  onClick={onImageUpload}
                  {...dragProps}
                >
                  Cargar Huella
                </button>
                &nbsp;
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img
                      src={image["data_url"]}
                      alt=""
                      width="100"
                      className="my-1"
                    />
                    <div className="image-item__btn-wrapper">
                      <button
                        onClick={() => onImageUpdate(index)}
                        className="btn btn-sm btn-dark me-1"
                      >
                        Cambiar
                      </button>
                      <button
                        onClick={() => onImageRemove(index)}
                        className="btn btn-sm btn-dark"
                      >
                        Borrar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades trabajarán con una
            versión del Documento Nacional de Identidad o DNI, el documento que
            nos identifica como peruanos y peruanas. Se trata de una versión de
            DNI hecha expresamente para estas actividades, es muy similar pero
            no es exactamente igual al verdadero.
          </li>

          <li>
            Lea la primera indicación: El DNI es el documento nacional de
            identificación que todos los peruanos y peruanas tenemos. Es para
            niños y niñas, hombres y mujeres, pobladores del campo o de la
            ciudad.
          </li>

          <li>
            Mencione que el DNI no solo acredita la identidad sino que, a través
            de él, el Estado nos reconoce como peruanos y, por lo tanto, es la
            puerta de acceso a nuestros derechos.
          </li>

          <li>
            Lea las siguientes indicaciones: Te presentamos un modelo de DNI
            donde se destaca el origen de nuestras familias. Completa tu DNI con
            los datos requeridos.
          </li>

          <li>
            Explique a niños y niñas que deben llenar sus datos.
            <ul>
              <li>
                <i>
                  En la primera imagen deben llenar los siguientes datos: Primer
                  apellido, Segundo apellido, Nombres, Nacimiento: fecha y
                  lugar, Fecha de inscripción (propóngales que sea una fecha
                  cercana a su nacimiento) Fecha de emisión (puede ser un mes
                  después de la fecha de inscripción), Fecha de caducidad
                  (proponga que sean 10 años después de la fecha de emisión),
                  Sexo.
                </i>
              </li>
            </ul>
          </li>
          <li>
            Recuerde que deben cargar una foto.
            <ul>
              <li>
                <i>
                  En la segunda imagen deben completar lo siguiente: Lugar de
                  origen del padre y lugar de origen de la madre (comente que,
                  en el DNI real, se indican aquí los nombres del padre y de la
                  madre. En su lugar, escribiremos dónde nacieron nuestros
                  padres porque nos interesa conocer de dónde vienen nuestras
                  familias. Si no conocen esta información, pida a niños y niñas
                  que la completen al llegar a casa); Dirección de la vivienda
                  del niño o niña (si no recuerdan su dirección, pida a niños y
                  niñas que completen este dato al llegar a casa); Distrito,
                  provincia y departamento (ayude si no
                  pueden completar esta información).
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
